import SecureLS from "secure-ls";

export function SalvarEnderecoClienteNoNavegador(cep, uf, cidade_nome, bairro_id, bairro_nome, endereco_nome, numero, complemento)
{
  var ls = new SecureLS();
  var enderecos = ls.get('enderecos');
  var endereco = {
    cep: cep,
    uf: uf,
    cidade_nome: cidade_nome,
    bairro_id: bairro_id,
    bairro_nome: bairro_nome,
    endereco: endereco_nome,
    numero: numero,
    complemento: complemento
  }
  if(enderecos)
  {
    enderecos.push(endereco);
    ls.set('enderecos',enderecos);
  }else{
    enderecos = [];
    enderecos.push(endereco);
    ls.set('enderecos',enderecos);
  }
}

export function SalvarInformacoesDoClienteNoNavegador(nome_cliente, telefone, cpf_nota, cpf)
{
  var ls = new SecureLS();
  ls.set('dados_cliente', {
    nome_cliente: nome_cliente,
    telefone: telefone,
    cpf_nota: cpf_nota,
    cpf: cpf
  });
}



// WEBPACK FOOTER //
// ./src/services/storage.js